import { mapValues } from 'lodash';
import { getPreference } from 'App/contexts/UserPreferences.utils';

const getExpandedStateFromSession = (baseKey, shape) => {
    return mapValues(shape, (val, key) => {
        const fullKey = `${baseKey}.${key}`;
        if (typeof val === 'object') {
            return getExpandedStateFromSession(fullKey, val);
        }
        return getPreference(fullKey, true);
    });
};

export default getExpandedStateFromSession;
